import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSalesPlan from './reducers/sales-plan.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SalesPlanEffects } from './effects/sales-plan.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromSalesPlan.salesPlanFeatureKey, fromSalesPlan.reducer),
    EffectsModule.forFeature([SalesPlanEffects])
  ]
})
export class SalesPlanStoreModule { }
